module.exports = __webpack_public_path__ + "static/img/icon_scan.0b9a4a4d.png";